import React from 'react';

const LabelPopupContent = ({ image, title, description }) => {
    return (
        <div>
            {image && (
                <img
                    src={image}
                    alt=""
                    style={{float: 'left', maxWidth: 100, marginRight: 15, marginBottom: 5}}
                />
            )}
            <p style={{margin: 0}}>
                {title && <strong>{title}<br/></strong>}
                {description}
            </p>
        </div>
    );
};

export default LabelPopupContent;
